export const patternMaker = (array) => {
  const arr = array.slice();
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === '') {
      arr[i] = '*';
    }
  }
  return arr;
};
